export const LOGO_UPLOAD_SIZE = 31457280 ;